export default __webpack_public_path__ + "static/media/signIn-bg2.5e0f069f.webp";